import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { FormRule } from 'antd';

export function usePhoneValidation(): FormRule[] {
    const { t } = useTranslation('translation');

    return useMemo<FormRule[]>(
        () => [
            {
                pattern: /^[0-9,+]*$/,
                message: t('phoneInputOnlyDigits'),
            },
            {
                pattern: /^.{0,16}$/,
                message: t('phoneInputMaxLength'),
            },
        ],
        [t],
    );
}
